module.exports = __webpack_public_path__ + "img/improve-health.95eb0552.png";